export type AppConfig = {
  VUE_APP_API_URL: string;
  VUE_APP_API_TIMEOUT: string;
  VUE_APP_MAX_MONITORED_TABLES?: string;
  VUE_APP_MIN_PERIOD?: string;
  VUE_APP_MIN_DATASOURCE_PERIOD?: string;
  VUE_APP_I18N_LOCALE?: string;
  VUE_APP_I18N_FALLBACK_LOCALE?: string;
  VUE_APP_TENANT?: string;
  VUE_APP_UNLEASH_URL?: string;
  VUE_APP_UNLEASH_CLIENT?: string;
  VUE_APP_TENANT_NAME: string;
  VUE_APP_INSTANCE_ID: string;
  VUE_APP_INSTANCE_ALIAS?: string;
  VUE_APP_AWS_INTEGRATION_ROLE_ARN?: string;
  VUE_APP_UNLEASH_ENVIRONMENT?: 'demo' | 'qa' | 'prod' | 'dev';
  // Values for SENTRY_ENVIRONMENT are aligned on values used by other services (such as the backend)
  VUE_APP_SENTRY_ENVIRONMENT?: 'demo' | 'qa' | 'production' | 'dev';
  VUE_APP_SENTRY_ENABLED?: 'true' | 'false';
  VUE_APP_PENDO_ENABLED?: 'true' | 'false';
  VUE_APP_PENDO_AI_AGENT_ID?: string;
  VUE_APP_CHAINLIT_URL?: string;
  VUE_APP_INTERCOM_ENABLED?: 'true' | 'false';
  VUE_APP_SIFFLET_AGENT_ENABLED?: 'true' | 'false';
  VUE_APP_SNOWFLAKE_NATIVE_APP_ENABLED?: 'true' | 'false';
  VUE_APP_ASSET_PREVIEW_ENABLED?: 'true' | 'false';
  VUE_APP_DASHBOARDS?: string;
}
declare global {
  interface Window {
    configs?: AppConfig;
    pendo?: {
      initialize?: (...args: unknown[]) => void;
      updateOptions?: (...args: unknown[]) => void;
      trackAgent?: (eventType: string, metadata: Record<string, unknown>) => void;
      enableDebugging?: () => void;
      [key: string]: unknown;
    };
  }
}

/**
 * Returns the current env
 * @param {string} name - The name of the env
 * @return string - The corresponding env
 */
export default function getEnv(name: keyof AppConfig): string | undefined {
  return window?.configs?.[name] || process.env[name]!;
}
